import * as React from 'react';
import { LoadingIndicator, UserMenu } from 'react-admin';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom'

const MyAppBar = props => {
    return (
        <AppBar color='secondary' {...props}>
            <Toolbar>
                <Link to="/users"><Box component="img" sx={{height: 64}} src='images/horizontal_logo.png'  /></Link>
                <Box sx={{flexGrow: 1}} />
                <LoadingIndicator />
                <UserMenu logout={props.logout} />
            </Toolbar>
        </AppBar>
    );
};

export default MyAppBar;